<template>
  <b-dropdown
    split
    split-variant="outline-primary"
    variant="primary"
    :text="selected.name"
    class="m-2"
  >
    <!--:active="compare(selected.dasharray, type.dasharray)"-->
    <b-dropdown-item-button
      v-for="type in types"
      :key="type.name"
      :active="compare(selected.value, type.value)"
      @click="handleTypeClick(type.value, type.linecap)"
    > <!-- Line -->
      <svg height="20" width="150">
        <g fill="none" stroke="currentColor" :stroke-linecap="type.linecap" stroke-width="4">
          <path :stroke-dasharray="type.dasharray" d="M5 10 l215 0" />
        </g>
      </svg>
    </b-dropdown-item-button>
  </b-dropdown>
</template>

<script>
export default {
  props: {
    lineType: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      types: [
        { name: 'Trait uni', dasharray: [], value: [], linecap: 'round' },
        { name: 'Tirets cadratins', dasharray: [40, 20], value: [20, 10], linecap: 'round' },
        { name: 'Tirets', dasharray: [20, 15], value: [10, 10], linecap: 'round' },
        { name: 'Tirets cadratin 2 points', dasharray: [40, 10, 0.5, 10, 0.5, 10], value: [20, 10, 0.5, 10, 0.5, 10], linecap: 'round' },
        { name: 'Tirets cadratin point', dasharray: [40, 10, 0.5, 10], value: [20, 10, 0.5, 10], linecap: 'round' },
        { name: 'Tirets point', dasharray: [20, 10, 0.5, 10], value: [10, 10, 0.5, 10], linecap: 'round' },
        { name: 'Point carré', dasharray: [2, 10, 0.001, 10], value: [10, 5, 5, 5], linecap: 'square' },
        { name: 'Tirets par défaut', dasharray: [10, 7], value: [4, 3], linecap: 'square' }
      ]
    }
  },
  computed: {
    selected () {
      return this.types.find(el => {
        return this.compare(this.lineType, el.value)
      })
    }
  },
  methods: {
    handleTypeClick (dasharray, linecap) {
      this.$emit('change', dasharray, linecap)
    },
    compare (arr1, arr2) {
      return JSON.stringify(arr1) === JSON.stringify(arr2)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/schemaFonctionnel/ui/lineTypeUI.vue